import React from 'react';
import Spinner from '../Spiner';
import { Container } from './styles';



const Preloader: React.FC = ( ) => {
    return (
        <Container>
            <Spinner />
        </Container>
    );
};

export  default Preloader